export const productKeys = {
  all: ["products"] as const,
  lists: () => [...productKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) =>
    [...productKeys.lists(), params] as const,
  details: () => [...productKeys.all, "detail"] as const,
  detail: (id: string) => [...productKeys.details(), id] as const,
  /**
   * Keyed on the UPPERCASED code because the backend matches case-insensitively
   * (`upper(sku) = ANY(...)`) — "KURTA-01" and "kurta-01" are the same question
   * and should not be two cache entries, or two requests.
   */
  skuAvailability: (sku: string, excludeRootId?: string) =>
    [...productKeys.all, "sku-availability", sku.toUpperCase(), excludeRootId ?? null] as const,
};
